import { downloadFileFromString } from 'src/common/downloadFile';

export function saveJsonString(json: string, filename = 'result.json') {
    try {
        const parsed = JSON.parse(json);
        downloadFileFromString(JSON.stringify(parsed, null, 2), filename, 'application/json');
    } catch {
        downloadFileFromString(json, filename, 'application/json');
    }
}

export function saveXmlString(xml: string, filename = 'result.xml') {
    downloadFileFromString(xml, filename, 'application/xml');
}
